
    import { Vue, Prop, Watch, Component } from "vue-property-decorator";
    import { Pedido, Estados } from '@/__env/lib/Ventas/Pedidos';
    import { ControladorInterfaz } from '../../controlador';

    @Component( {
        name: "Componente",
        props: {},
        components: {
        }
    } )
    export default class Componente extends Vue
    {
        @Prop()
        public Controlador: ControladorInterfaz;
        public get Pedido() { return this.Controlador.Pedido; }
        public get Estado() { return this.Controlador.Vista.Estado; }

        get Items()
        {
            return [

                {
                    icono: 'check',
                    valor: 'Autorizado',
                    id: [Estados.Autorizado.Id, Estados.Preparando.Id],
                },
                {
                    icono: 'cart',
                    valor: 'Facturado',
                    id: [
                        Estados.Facturado.Id,
                        Estados.ListoParaDespachar.Id,
                        Estados.ListoParaRetirar.Id
                    ],
                },
                {
                    icono: 'truck',
                    valor: 'Despachado',
                    id: [Estados.Despachado.Id],
                },
                {
                    icono: 'home',
                    valor: 'Entregado',
                    id: [Estados.Entregado.Id],
                }
            ];
        }


        get Errores()
        {
            return [

                {
                    icono: 'close-circle',
                    valor: 'Cancelado',
                    id: [Estados.Cancelado.Id],
                },
                {
                    icono: 'close-circle',
                    valor: 'No autorizado',
                    id: [
                        Estados.NoAutorizado.Id,
                    ],
                },
                {
                    icono: 'close-circle',
                    valor: 'Devuelto',
                    id: [Estados.Devuelto.Id],
                },
                {
                    icono: 'close-circle',
                    valor: 'No entregado',
                    id: [Estados.NoEntregado.Id],
                }
            ];
        }


        protected Eventos: Function[] = [];
        beforeDestroy()
        {
            this.Eventos.forEach( x => x() );
        }
        mounted()
        {
            this.Eventos.push( this.Controlador.Vista.onEstado.subscribe( ( x ) => this.Iniciar() ) );
            this.Iniciar();
        }

        HayError: boolean = false;
        Activo: number = 0;

        Iniciar()
        {
            this.Activo = -2;
            this.HayError = false;
            if ( this.Estado == 'iniciado' )
            {
                this.Activo = this.Errores.findIndex( x => x.id.includes( this.Pedido.Estado.Id ) ) + 1;

                if ( this.Activo == 0 )
                {
                    this.Activo = this.Items.findIndex( x => x.id.includes( this.Pedido.Estado.Id ) ) + 1;
                    this.HayError = false;
                } else
                {
                    this.HayError = true;
                }

            }
        }

        get W(): string
        {
            if ( this.HayError )
                return ( 100 / this.Errores.length - 8 ).toString() + '%';
            else
                return ( 100 / this.Items.length - 8 ).toString() + '%';
        }
        get W2(): string
        {
            if ( this.HayError )
                return ( 100 / this.Errores.length - 3 ).toString() + '%';
            else
                return ( 100 / this.Items.length - 3 ).toString() + '%';
        }
    }
